import { useSchool } from '../context/SchoolContext';
import { Bell, User, Menu } from 'lucide-react';
import './Header.css';

const Header = ({ title = 'Dashboard', onMenuClick }) => {
    const { branches, selectedBranch, setSelectedBranch } = useSchool();

    return (
        <header className="header">
            <div className="header-left">
                <button className="menu-toggle-btn" onClick={onMenuClick}>
                    <Menu size={24} />
                </button>
                <h1 className="page-title">{title}</h1>
            </div>

            <div className="header-right">
                <div className="filter-group">
                    <label>BRANCH</label>
                    <select
                        value={selectedBranch}
                        onChange={(e) => setSelectedBranch(e.target.value)}
                        className="branch-select"
                    >
                        <option value="All Branches">All Branches</option>
                        {branches.map(branch => {
                            const name = branch.branch_name || branch.name || '';
                            return (
                                <option key={branch.id || branch.branch_id} value={name}>
                                    {name}
                                </option>
                            );
                        })}
                    </select>
                </div>

                <div className="filter-group">
                    <label>FROM:</label>
                    <input type="date" defaultValue="2026-01-01" className="date-input" />
                </div>

                <div className="filter-group">
                    <label>TO:</label>
                    <input type="date" defaultValue="2026-10-31" className="date-input" />
                </div>

                <button className="icon-btn">
                    <Bell size={20} />
                </button>

                <div className="user-profile">
                    <span className="user-name">Nyasha</span>
                    <span className="user-role">Business Owner</span>
                    <div className="user-avatar">
                        <User size={20} />
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
